export default __webpack_public_path__ + "static/media/add-circle-filled.a7750fa2.svg";